import { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewCard,
} from "../../components/Component";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";
import styles from "../location/location.module.scss";
import parse from "html-react-parser";
import { Button, Col, Modal, ModalBody, Row, Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getHomePageByType, updateHomepageType } from "../../redux/Apislices/homepageSlice";
import TinyMceEditor from "../components/forms/rich-editor/TinyMceEditor";
import { generateFAQSchema } from "../../utils/Utils";

const FaqsPage = () => {
  const dispatch = useDispatch();
  const { homepage } = useSelector((state) => ({
    homepage: state.homepage,
  }));
  console.log("homepage: ", homepage);

  const [view, setView] = useState(false);
  const [page, setPage] = useState("");
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");

  const [faq, setFaq] = useState([]);
  const [faqSchema, setFaqSchema] = useState("");
  console.log("faq: ", faq);

  const [faqEditIndex, setFaqEditIndex] = useState(null);

  const toggleView = () => {
    setView(!view);
    fetchData();
  };

  const fetchData = async () => {
    await dispatch(getHomePageByType("Faqs"));
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (homepage?.homepage?.faqs?.length) setFaq(homepage?.homepage?.faqs);
    else setFaq([]);
    if (homepage?.homepage?.faqSchema) setFaqSchema(homepage?.homepage?.faqSchema);
    else setFaqSchema("");
  }, [homepage?.homepage?.faqs]);

  const handleAdd = (e) => {
    e.preventDefault();

    let payload = { type: "Faqs", faqs: faq, faqSchema };

    if (faq?.length) {
      dispatch(
        updateHomepageType(
          "Faqs",
          payload,
          (res) => {
            console.log("res: ", res);
            toast.success("FAQs added/updated successfully");
            fetchData();
          },
          (err) => {
            console.log("err: ", err);
            toast.error(err?.message || "An error occurred while adding FAQs");
          }
        )
      );
      setView(false);
    } else {
      toast.error("Please add at least one FAQ");
    }
  };

  useEffect(() => {
    if (faq?.length) setFaqSchema(generateFAQSchema(faq));
  }, [faq]);

  return (
    <>
      <Head title="Faqs" />

      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag={"h1"}>
                FAQs
              </BlockTitle>
            </BlockHeadContent>

            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <div className="toggle-expand-content" style={{}}>
                  <ul className="nk-block-tools g-3">
                    <li>
                      <button className="btn btn-primary" onClick={() => toggleView("add")}>
                        Add/Edit FAQs
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <PreviewCard>
            {homepage?.loading ? (
              <div
                style={{
                  height: "200px",
                  width: "100%",
                  display: "grid",
                  placeItems: "center",
                }}
              >
                <Spinner type="grow" color="dark" />
              </div>
            ) : homepage?.homepage?.faqs?.length ? (
              <Accordion className={styles.a} preExpanded={[1]}>
                {homepage?.homepage?.faqs?.map((li, i) => {
                  return (
                    <AccordionItem key={i} uuid={i + 1}>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          <div>
                            <div>{parse(li?.question || "")}</div>
                          </div>
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <div className="answerContent">{parse(li?.answer || "")}</div>
                      </AccordionItemPanel>
                    </AccordionItem>
                  );
                })}
              </Accordion>
            ) : homepage?.success && !homepage?.homepage?.faqs?.length ? (
              <div className="text-center" style={{ padding: "2rem" }}>
                <h4>No FAQs found</h4>
                <p>Click on the button above to add FAQs</p>
              </div>
            ) : null}
          </PreviewCard>
        </Block>
      </Content>

      <Modal isOpen={view} toggle={() => toggleView()} className="modal-dialog-centered" size="lg">
        <ModalBody>
          <a href="#cancel" className="close">
            <Icon name="cross-sm" onClick={() => toggleView()}></Icon>
          </a>
          <div className="p-2">
            <h5 className="title">
              <span>Add/Edit FAQs</span>
            </h5>

            <div className="card-inner p-0">
              <div className="p-2">
                <div className="mt-4">
                  <form onSubmit={handleAdd}>
                    <Row className="">
                      <Col lg="12" className="form-group">
                        <label className="form-label">Question</label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Question"
                            value={question}
                            onChange={(e) => setQuestion(e.target.value)}
                          />
                        </div>
                      </Col>
                      <Col lg="12" className="form-group">
                        <label className="form-label">Answer</label>
                        <div className="form-control-wrap">
                          <TinyMceEditor value={answer} getValue={setAnswer} placeholder={"Enter the details"} />
                        </div>
                      </Col>

                      <Col md="12">
                        {faqEditIndex !== null ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "1rem",
                            }}
                          >
                            <Button
                              color="primary"
                              onClick={() => {
                                if (!question || !answer) return toast.error("Title and content both are required");
                                let newFaq = [...faq];
                                let data = { question, answer };
                                newFaq?.splice(faqEditIndex, 0, data);
                                setFaq(newFaq);
                                setQuestion("");
                                setAnswer("");
                                setFaqEditIndex(null);
                              }}
                              type="button"
                            >
                              <span>Update</span>
                            </Button>
                            <Button
                              color="primary"
                              onClick={() => {
                                let newFaq = [...faq];
                                let data = { question, answer };
                                newFaq?.splice(faqEditIndex, 0, data);
                                setFaq(newFaq);
                                setQuestion("");
                                setAnswer("");
                                setFaqEditIndex(null);
                              }}
                              type="button"
                            >
                              <span>Cancel</span>
                            </Button>
                          </div>
                        ) : (
                          <Button
                            color="primary"
                            onClick={() => {
                              // console.log("question: ", question);
                              // console.log("answer: ", answer);
                              if (!question || !answer) return toast.error("Question and answer both are required");
                              setFaq([...faq, { question, answer }]);
                              setQuestion("");
                              setAnswer("");
                            }}
                            type="button"
                          >
                            <span>Add</span>
                          </Button>
                        )}
                      </Col>

                      <hr style={{ width: "100%", height: "1px", background: "#a0a0a0", color: "#a0a0a0" }} />

                      <Col md="12">
                        {faq?.length ? (
                          <Accordion className={styles.a}>
                            {faq?.map((li, i) => {
                              return (
                                <AccordionItem key={i} uuid={i + 1}>
                                  <AccordionItemHeading>
                                    <AccordionItemButton>
                                      <div>
                                        <div>{parse(li?.question || "")}</div>
                                        <div className={styles.CTASection}>
                                          <div
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setQuestion(li?.question);
                                              setAnswer(li?.answer);
                                              setFaqEditIndex(i);
                                              setFaq(faq.filter((item, index) => index !== i));
                                            }}
                                            className={styles.edit}
                                          >
                                            <Icon name="edit" />
                                          </div>
                                          <div
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setFaq(faq.filter((item, index) => index !== i));
                                            }}
                                            className={styles.close}
                                          >
                                            <Icon name="cross" />
                                          </div>
                                        </div>
                                      </div>
                                    </AccordionItemButton>
                                  </AccordionItemHeading>
                                  <AccordionItemPanel>
                                    <div className="answerContent">{parse(li?.answer || "")}</div>
                                  </AccordionItemPanel>
                                </AccordionItem>
                              );
                            })}
                          </Accordion>
                        ) : null}
                      </Col>

                      <hr style={{ width: "100%", height: "1px", background: "#a0a0a0", color: "#a0a0a0" }} />

                      <Col md="12" className="">
                        <div className="form-group">
                          <label className="form-label">FAQ Schema</label>
                          <div className="form-control-wrap mb-2">
                            <textarea
                              value={faqSchema}
                              name="faqSchema"
                              id="faqSchema"
                              disabled
                              className="form-control"
                              rows={2}
                              placeholder="text..."
                              onChange={(e) => {
                                setFaqSchema(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                      </Col>

                      <Col md="12" className="mt-4 text-center">
                        <Button color="primary" type="submit" className="">
                          <span>{"Save"}</span>
                        </Button>
                      </Col>
                    </Row>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default FaqsPage;
